import React from 'react';
import {Content, Container, DataContainer, Text} from 'app/components/matchEvents/MatchEventStyles';
import {Image, Typography} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import {FlexContainer} from 'app/styles/content';
import styled from 'styled-components';
import MatchEventMinute from 'app/components/matchEvents/MatchEventMinute';

const ChanceWrapper = styled(FlexContainer)`
  align-items: center;
  gap: 0.5rem;
`;

const MatchEventChance = ({event}) => {
  const standingMessage = `Großchance💥 für ${event.team?.name?.middle ?? 'Unbekannt'}`;
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;

  const showPlayerName = event.primaryRole?.player ? (
    <LinkOnComponent to={`/player/${event.primaryRole.player.slug}`}>
      <Typography variant='body2'>
        {event.primaryRole.player.firstName} {event.primaryRole.player.lastName}
      </Typography>
    </LinkOnComponent>
  ) : null;

  const teamEmblem = event.team?.image ? (
    <Image entity='emblem' src={event.team.image} ratio='1:1' width={36} height={36} fit={true} />
  ) : null;

  return (
    <Content>
      <Container>
        <MatchEventMinute minute={time} />
        <DataContainer>
          <ChanceWrapper>
            {teamEmblem}
            <div>
              <Typography variant='body1'>{standingMessage}</Typography>
              {showPlayerName}
            </div>
          </ChanceWrapper>
          <Text withPadding variant='body2'>
            {event.text}
          </Text>
        </DataContainer>
      </Container>
    </Content>
  );
};

export default MatchEventChance;
